<main>
  <div class="app-pre-loader" *ngIf="areTranslationsLoading">
    Loading<span class="d">.</span><span class="d d-2">.</span><span class="d d-3">.</span>
  </div>
  <div id="root">
    <app-loader *ngIf="areTranslationsLoading"></app-loader>
    <app-navbar *ngIf="isUserLoggedIn() && !areTranslationsLoading"></app-navbar>
    <router-outlet *ngIf="!areTranslationsLoading"></router-outlet>
    <chapps-request-error-modal></chapps-request-error-modal>
  </div>
</main>
<chapps-icon-sprite-map></chapps-icon-sprite-map>

